import React, { useEffect, useState } from "react";
import toast , { Toaster } from "react-hot-toast";
import { useNavigate } from "react-router-dom";



function Dashboard() {


     const navigate = useNavigate();

  useEffect(() => {
    const isAuth = localStorage.getItem("admin_auth");

    if (!isAuth) {
      navigate("/admin/biome-login");
    }
  }, [navigate]);


const [users, setUsers] = useState([]);
const [page, setPage] = useState(1);
const limit = 12;

  // fetch users
 const loadUsers = () => {
  fetch(`/api/users.php?page=${page}&limit=${limit}`)
    .then((res) => res.json())
    .then((data) => {
      setUsers(data.data || []);
    });
};

useEffect(() => {
  loadUsers();
}, [page]);



  // 🗑 delete user
  const handleDelete = async (id) => {
    const confirmDelete = window.confirm("Delete this user?");
    if (!confirmDelete) return;

    try {
      const res = await fetch(
        "/api/delete_user.php",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ id }),
        }
      );

      const data = await res.json();

      if (data.status === "success") {
        toast.success("User deleted ✅");

        // remove from UI instantly (no reload)
        setUsers(users.filter((u) => u.id !== id));
      } else {
        toast.error("Delete failed");
      }
    } catch (err) {
      toast.error("Server error");
    }
  };


  const handleLogout = () => {
  localStorage.removeItem("admin_auth");
  window.location.href = "/admin/biome-login";
};



  return (
<div className="dody-container">
    <Toaster/>
     <div  className="biome biome-24">
          <div className="biome-table-header">
              <h2>User Dashboard</h2>
              <button onClick={handleLogout}><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-box-arrow-in-right" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M6 3.5a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 0-1 0v2A1.5 1.5 0 0 0 6.5 14h8a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-8A1.5 1.5 0 0 0 5 3.5v2a.5.5 0 0 0 1 0z"/>
  <path fill-rule="evenodd" d="M11.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H1.5a.5.5 0 0 0 0 1h8.793l-2.147 2.146a.5.5 0 0 0 .708.708z"/>
</svg> Logout</button>
          </div>
          <div className="biome-list-container">
 <table border="1" cellPadding="10">
        <thead>
          <tr>
            <th>ID</th>
            <th>Email</th>
            <th>Mobile</th>
            <th>Date</th>
            <th>Action</th>
          </tr>
        </thead>

        <tbody>
          {users.map((u) => (
            <tr key={u.id}>
              <td>{u.id}</td>
              <td>{u.email}</td>
              <td>{u.mobile}</td>
              <td>{u.created_at}</td>
              <td>
                <button onClick={() => handleDelete(u.id)} className="delete">
                 <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash-fill" viewBox="0 0 16 16">
  <path d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5M8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5m3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0"/>
</svg> Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
          </div>
          <div className="flex-nav-table">
  <button
    onClick={() => setPage(page - 1)}
    disabled={page === 1}
  >
    ⬅ Prev
  </button>

  <span style={{ margin: "0 10px" }}>
    Page {page}
  </span>

  <button
    onClick={() => setPage(page + 1)}
    disabled={users.length < limit}
  >
    Next ➡
  </button>
</div>
     </div>
    </div>
  );
}

export default Dashboard;